import React from 'react';
import { getFeaturesForMetro } from '../data/features';

export function FilterChipList({ items, selected, onToggle }) {
  return (
    <div className="flex flex-col gap-2 max-h-56 overflow-y-auto pr-1">
      {items.map((item) => {
        const key = typeof item === 'string' ? item : item.key;
        const label = typeof item === 'string' ? item : item.label;
        const isSelected = selected.includes(key);
        return (
          <button
            key={key}
            type="button"
            onClick={() => onToggle(key)}
            className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-all ${
              isSelected
                ? 'bg-dive-amber text-black'
                : 'bg-dive-gray text-gray-300 hover:bg-dive-light'
            }`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}

function FeatureFilterChips({ selectedFeatures, onToggle, metroId }) {
  return (
    <FilterChipList
      items={getFeaturesForMetro(metroId)}
      selected={selectedFeatures}
      onToggle={onToggle}
    />
  );
}

export default FeatureFilterChips;
